import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";

type ProjectSetupModal = "starterSites" | null;

export function useSelectInitialProjectSetupModal(): {
  modalToShow: ProjectSetupModal;
} {
  const { project, isLoading, projectId } = useCurrentProjectContext();

  const hasStyleLibrary = Boolean(project?.styleLibrary);
  const isReploHosting = project?.hostingType === "replo";
  const hasOnboardedStarterSites = Boolean(project?.hasOnboardedStarterSites);

  if (isLoading || !projectId || !isReploHosting || hasStyleLibrary) {
    return { modalToShow: null };
  }

  if (!hasOnboardedStarterSites) {
    return { modalToShow: "starterSites" };
  }

  return { modalToShow: null };
}
